module.exports = __webpack_public_path__ + "viasport-logo-fi-130428ec8a5ae105e21cbff2f284830d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viasport-logo-fi.png
// module id = 1065
// module chunks = 0 1 2